export default [
    {
      path: '/',
      name: 'home',
      component: () => import('@/components/StartPage.vue'),
    },
  ];